export const PROFITABILITY_SORT_OPTIONS = Object.freeze({
	MARKET: 'Market',
	PROFITABILITY: 'Profitability',
});
